// 测试 JCB 会员用户
const JCB_MEMBER_USERS = [
  "U0532108261", // caohui, sg
  "U0812104574", // caohui, jp
  "U0532105756", // linna, sg
  "U0812307662" // beryl, jp
];

/**
 * 判断用户是否为 JCB 会员
 * @param user 用户对象
 * @returns {boolean} 是否为 JCB 会员
 */
export const isJcbMember = user => {
  return (
    user?.loyaltyProgram?.coBrandedCard?.issuer === "jcb" ||
    JCB_MEMBER_USERS.includes(user?.no)
  );
};
